import { Entity, FieldType, makeClone, PersistenceType } from 'gossamer-unified';
import { Institution } from './Institution';

export type InstitutionViewRow = {
  id: number;
  name: string;
  type: string;
  logo: string | null;
  banner: string | null;
  description: string | null;
  address: string | null;
  contact_email: string | null;
  contact_phone: string | null;
  stripe_connect_payouts_enabled: boolean;

  parent_id: number | undefined;
  parent_name: string | undefined;
  parent_logo: string | undefined;
  number_of_children: number;
  follower_count: number;
};

const clone = makeClone();

export const InstitutionView: Entity<InstitutionViewRow> = {
  id: 'InstitutionView',
  title: 'Institution',
  service: 'main',
  rowLabel: (row: InstitutionViewRow) => row.name,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.institution_view',
  },
  security: [
    {
      role: 'all',
      action: 'read',
      access: 'all',
    },
  ],
  defaultSort: [['name', 'ASC']],
  defaultFilters: Institution.defaultFilters,
  listRowLink: Institution.listRowLink,
  fields: {
    id: clone(Institution.fields.id),
    name: clone(Institution.fields.name),
    type: clone(Institution.fields.type),
    logo: clone(Institution.fields.logo),
    banner: clone(Institution.fields.banner),
    description: clone(Institution.fields.description),
    address: clone(Institution.fields.address),
    contact_email: clone(Institution.fields.contact_email),
    contact_phone: clone(Institution.fields.contact_phone),
    stripe_connect_payouts_enabled: clone(Institution.fields.stripe_connect_payouts_enabled),
    parent_id: {
      seq: 500,
      label: 'Parent Institution Id',
      type: FieldType.Integer,
    },
    parent_name: {
      seq: 510,
      label: 'Parent Institution Name',
      type: FieldType.Text,
    },
    parent_logo: {
      seq: 520,
      label: 'Parent Institution Logo',
      type: FieldType.Text,
    },
    number_of_children: {
      seq: 530,
      label: 'Number of Child Institutions',
      type: FieldType.Integer,
    },
    follower_count: {
      seq: 990,
      label: 'Follower Count',
      type: FieldType.Integer,
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
    },
  },
};
